module.exports = "/public/images/e09aa4fac25cab769710e92d60e17124.svg";